import './ParallaxImage.css';

function ParallaxImage({id, image, properties, desktopOnly, noMobile}) {
  return (<img id={id || ""} className={"ParallaxImage" + (desktopOnly ? " desktopOnly" : "") + (noMobile ? " noMobile" : "")} style={properties} src={image} />);
}

export default ParallaxImage;
